import api from "./admin_api_global";

export const searchUsers = (q) =>
  api.get(`/admin/user-sessions/search`, { params: { q } }).then((r) => r.data);

export const getUserSessionSummary = (userId) =>
  api.get(`/admin/user-sessions/${userId}`).then((r) => r.data);

export const assignSessions = (userId, planType, sessions) =>
  api.post(`/admin/user-sessions/${userId}/assign`, { planType, sessions }).then((r) => r.data);
